<template>
      <div id="welcome-to-anthem">
            <section class="section welcome-anthem-hero animate__animated animate__fadeIn">
                  <BackButton v-if="currMember == 'New Prospective'" link="/considering-coverage-new" />
                  <BackButton v-else link="/keeping-plan" />
                  <div class="grid-container max">
                        <div class="welcome-anthem-grid">
                              <div class="welcome-anthem-left">
                                    <h1>Why Anthem is a<br />smart choice</h1>
                                    <p class="welcome-anthem-subtitle">Across Georgia, the country, or around the world</p>
                                    <p class="welcome-anthem-desc">We serve more than 40 million members nationwide with programs and provider networks that go beyond typical health plans.</p>
                                    <p class="welcome-anthem-benefits-label">Our members benefit from:</p>
                                    <div class="welcome-anthem-benefit">
                                          <h5>One of the largest networks in Georgia</h5>
                                          <p>Confidence in finding an in-network doctor<sup>1</sup></p>
                                    </div>
                                    <div class="welcome-anthem-benefit">
                                          <h5>National coverage</h5>
                                          <p>Extensive national networks for both the HMO and HRA plans</p>
                                    </div>
                                    <div class="welcome-anthem-benefit">
                                          <h5>Coverage when traveling outside the US</h5>
                                          <p>In-network doctors/hospitals in nearly 190 countries and territories worldwide<sup>2</sup></p>
                                    </div>
                                    <div class="welcome-anthem-benefit">
                                          <h5>Discounted rates with in-network providers</h5>
                                    </div>
                              </div>
                              <div class="welcome-anthem-right">
                                    <div class="welcome-anthem-box">
                                          <h5>Anthem&rsquo;s Plan Options provide support 24/7, including:</h5>
                                          <div class="welcome-anthem-icons">
                                                <div class="welcome-anthem-icon-item">
                                                      <img src="~@/assets/img/wellbeing-solutions-icon.svg" alt="" />
                                                      <p>Health information on the go via the Sydney<sup>SM</sup> Health mobile app</p>
                                                </div>
                                                <div class="welcome-anthem-icon-item">
                                                      <img src="~@/assets/img/brain-icon.svg" alt="" />
                                                      <p>Behavioral Health Resource Center</p>
                                                </div>
                                                <div class="welcome-anthem-icon-item">
                                                      <img src="~@/assets/img/wifi-icon.svg" alt="" />
                                                      <p>A dedicated website at <a href="https://anthem.com/shbp" target="_blank" @click="track('Link', 'anthem.com/shbp - Welcome To Anthem')">anthem.com/shbp</a></p>
                                                </div>
                                                <div class="welcome-anthem-icon-item">
                                                      <img src="~@/assets/img/stethoscope-new-icon.svg" alt="" />
                                                      <p>Registered nurses via our NurseLine</p>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <p class="welcome-anthem-footnote">1. Network subject to change. 2. Coverage with the Blue Cross Blue Shield Global Core Program, GeoBlue website, more than 20 years as a leader in international healthcare (accessed August 2026): about.geo-blue.com. GeoBlue is the trade name for the international health insurance program of Worldwide Insurance Services (WIS), an independent licensee of Blue Cross Blue Shield Association. Blue Cross Blue Shield Association is an association of independent Blue Cross and Blue Shield companies. Blue Cross Blue Shield Global is a brand owned by Blue Cross Blue Shield Association.</p>
                  </div>
                  <div class="welcome-anthem-btn-wrap">
                        <router-link to="/checklist" class="welcome-anthem-btn"><span>Next</span></router-link>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPWelcomeToAnthem",
            data (){
                  return{
                         currMember:this.$store.state.currMember
                  }
            },
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#welcome-to-anthem {
      .welcome-anthem-hero {
            background-color: #ffffff;
            margin-top: 68px;
            padding: 120px 0 160px 0;
            position: relative;

            .back-btn {
                  left: 86px;
                  border-color: #1254E8;

                  &::before {
                        background-image: none;
                        background-color: #1254E8;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .welcome-anthem-grid {
                  display: flex;
                  flex-wrap: wrap;
                  align-items: flex-start;
                  justify-content: space-between;
                  gap: 64px;
                  margin-top: 48px;
            }

            .welcome-anthem-left {
                  flex: 1 1 520px;
                  max-width: 680px;

                  h1 {
                        color: #1355E9;
                        font-size: clamp(2.75rem, 4.5vw, 4.25rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 32px;
                  }

                  .welcome-anthem-subtitle {
                        color: #012E58;
                        font-size: 1.375rem;
                        font-weight: 600;
                        line-height: 1.3;
                        margin-bottom: 16px;
                  }

                  .welcome-anthem-desc {
                        color: #3F3A4E;
                        font-size: 1rem;
                        line-height: 1.6;
                        margin-bottom: 32px;
                  }

                  .welcome-anthem-benefits-label {
                        color: #012E58;
                        font-weight: 700;
                        font-size: 1.125rem;
                        margin-bottom: 16px;
                  }

                  .welcome-anthem-benefit {
                        margin-bottom: 20px;

                        h5 {
                              color: #1355E9;
                              font-weight: 700;
                              font-size: 1.125rem;
                              margin-bottom: 2px;
                        }

                        p {
                              color: #3F3A4E;
                              font-size: 1rem;
                              line-height: 1.5;
                              margin-bottom: 0;
                        }
                  }
            }

            .welcome-anthem-right {
                  flex: 1 1 380px;
                  max-width: 460px;

                  .welcome-anthem-box {
                        background-color: #0A2C4C;
                        color: #ffffff;
                        padding: 40px;

                        h5 {
                              color: #ffffff;
                              font-weight: 700;
                              font-size: 1.25rem;
                              line-height: 1.3;
                              margin-bottom: 32px;
                        }
                  }

                  .welcome-anthem-icons {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 32px 24px;
                  }

                  .welcome-anthem-icon-item {
                        img {
                              width: 40px;
                              height: 40px;
                              object-fit: contain;
                              margin-bottom: 12px;
                              filter: brightness(0) invert(1);
                        }

                        p {
                              color: rgba(255, 255, 255, 0.9);
                              font-size: 0.875rem;
                              line-height: 1.4;
                              margin-bottom: 0;

                              a {
                                    color: #ffffff !important;
                                    font-weight: 700;
                                    text-decoration: underline;
                              }
                        }
                  }
            }

            .welcome-anthem-footnote {
                  color: #6b6b6b;
                  font-size: 0.75rem;
                  line-height: 1.6;
                  margin-top: 48px;
                  margin-bottom: 0;
            }

            .welcome-anthem-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  background-color: #ffffff;
                  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.10);
                  padding: 20px 0;
                  text-align: center;
            }

            .welcome-anthem-btn {
                  display: block;
                  background-color: #1355E9;
                  color: #ffffff !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 330px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;
                  margin: 0 auto;

                  &:hover {
                        background-color: #44B8F3;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 140px 24px;

                  .back-btn {
                        left: 2rem;
                  }

                  .welcome-anthem-grid {
                        flex-direction: column;
                        gap: 40px;
                        margin-top: 32px;
                  }

                  .welcome-anthem-left {
                        flex: 0 0 auto;
                        max-width: 100%;

                        h1 {
                              font-size: clamp(2rem, 8vw, 3rem) !important;
                        }
                  }

                  .welcome-anthem-right {
                        flex: 0 0 auto;
                        max-width: 100%;

                        .welcome-anthem-box {
                              padding: 32px 24px;
                        }
                  }

                  .welcome-anthem-icons {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 24px 16px;
                  }
            }
      }
}
</style>
